<template>
  <div class="form-group" :class="{ 'input-group': hasIcon }">
    <slot name="label">
      <label v-if="label" class="control-label">
        {{ label }}
      </label>
    </slot>
    <slot name="addonLeft">
      <span
        v-if="addonLeftIcon"
        @click="clickedIcon"
        class="input-group-prepend"
      >
        <span class="input-group-text" :class="iconClasses">
          <font-awesome-icon :icon="addonLeftIcon" />
        </span>
      </span>
    </slot>
    <input
      :value="value"
      @input="$emit('input', $event.target.value)"
      v-on:keyup.enter="$emit('keyupEnter')"
      v-bind="$attrs"
      class="form-control"
      aria-describedby="addon-right addon-left"
    />
    <slot></slot>
    <slot name="addonRight">
      <span
        v-if="addonRightIcon"
        @click="clickedIcon"
        class="input-group-append"
      >
        <span class="input-group-text" :class="iconClasses">
          <font-awesome-icon :icon="addonRightIcon" />
        </span>
      </span>
      <span v-if="addonRightText" class="input-group-append">
        <span class="input-group-text"
          ><small>{{ addonRightText }}</small></span
        >
      </span>
    </slot>
  </div>
</template>
<script>
export default {
  inheritAttrs: false,
  name: "fg-input",
  props: {
    label: String,
    value: [String, Number],
    addonRightIcon: String,
    addonLeftIcon: String,
    addonRightText: String,
    iconClasses: Array
  },
  methods: {
    clickedIcon() {
      this.$emit("clickedIcon");
    }
  },
  computed: {
    hasIcon() {
      const { addonRight, addonLeft } = this.$slots;
      return (
        addonRight !== undefined ||
        addonLeft !== undefined ||
        this.addonRightIcon !== undefined ||
        this.addonLeftIcon !== undefined ||
        this.addonRightText
      );
    }
  }
};
</script>
<style></style>
